import { useCallback, useEffect, useState } from 'react';

export const ZOPIM_CHAT_READY_EVENT = 'zopim-chat-ready';

const useZopimChat = () => {
    const [shouldOpenWhenReady, setShouldOpenWhenReady] = useState(false);

    const runWithZopim = useCallback((callback: () => void) => {
        if (typeof window === 'undefined' || !window.$zopim) return false;

        window.$zopim(callback);
        return true;
    }, []);

    const openChat = useCallback(() => {
        const didOpen = runWithZopim(() => {
            window.$zopim?.livechat?.window?.show?.();
        });

        if (!didOpen) {
            setShouldOpenWhenReady(true);
        }
    }, [runWithZopim]);

    const closeChat = useCallback(() => {
        runWithZopim(() => {
            window.$zopim?.livechat?.window?.hide?.();
        });
    }, [runWithZopim]);

    useEffect(() => {
        if (!shouldOpenWhenReady) return;

        const openWhenReady = () => {
            const didOpen = runWithZopim(() => {
                window.$zopim?.livechat?.window?.show?.();
            });

            if (didOpen) {
                setShouldOpenWhenReady(false);
            }
        };

        openWhenReady();
        window.addEventListener(ZOPIM_CHAT_READY_EVENT, openWhenReady);

        return () => {
            window.removeEventListener(ZOPIM_CHAT_READY_EVENT, openWhenReady);
        };
    }, [runWithZopim, shouldOpenWhenReady]);

    return {
        closeChat,
        openChat,
    };
};

export default useZopimChat;
